module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('data-table', {
    attrs: {
      "table-ref": "rentalduetable",
      "url": "/report/property/due",
      "fields": _vm.fields,
      "title": "Tenancy Due",
      "icon": "fa fa-asterisk",
      "search-placeholder": "Site name, Landlord..."
    }
  }), _vm._v(" "), _c('events-calendar', {
    attrs: {
      "category": "tenancy"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-55c535ee"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/dashboard/property/TenancyDue.vue
// module id = 1497
// module chunks = 0